
export const PublicMarketCountryMultiget = new TypedDocumentString(`
    query PublicMarketCountryMultiget($iso2: [String!]!) {
  publicMarketCountryMultiget(iso2: $iso2) {
    ...MarketCountry
    __typename
  }
}
    fragment DocumentColorHsla on DocumentColorHsla {
  h
  s
  l
  a
  __typename
}
fragment ImageNodeItem on ImageNodeItem {
  _id
  alt
  uploadDate
  type
  url
  fallbackUrl
  img
  height
  width
  noProxy
  hsla {
    ...DocumentColorHsla
    __typename
  }
  aspect {
    x
    y
    __typename
  }
  audio
  videoHls
  video
  isVideo
  __typename
}
fragment Image on Image {
  alt {
    value
    __typename
  }
  isVideo
  image2 {
    ...ImageNodeItem
    __typename
  }
  __typename
}
fragment MarketCountry on MarketCountry {
  id
  iso2
  continent
  priority
  telCode
  title {
    value
    __typename
  }
  isEu
  altname
  img {
    ...Image
    __typename
  }
  __typename
}`, {"hash":"8b0759fb821e7d1cb31681106c0f138cfe8aae52bdbec1f5a7b4a26141bcc793"});